import { LoadingScreen } from "@/components/elements/Loading/Loading";
import { AppRoutes, GuestRoutes } from "@/routes/config";
import { verifyToken } from "@/utils/token";
import Cookies from "js-cookie";
import { FC, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Guards the guest-only pages (login, register, password recovery): a user with
 * a still-valid token is sent home instead of being shown a login form again.
 */
export const withGuest: <CP extends {}>(WrappedComponent: FC<CP>) => FC<CP> = (WrappedComponent) => (props) => {
  const { pathname } = useLocation();
  const [isVerified, setIsVerified] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = Cookies.get("match_token");
    const isAuthenticated = !!token && verifyToken(token);

    if (isAuthenticated && GuestRoutes.some((path) => pathname.startsWith(path))) {
      navigate(AppRoutes.home, { replace: true });
      return;
    }

    setIsVerified(true);
  }, [pathname, navigate]);

  if (!isVerified) return <LoadingScreen />;

  return <WrappedComponent {...props} />;
};
